import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { COOKIE_CONSENT_KEY, applyConsent } from "@/utils/googleAnalytics";

const STORAGE_KEY = COOKIE_CONSENT_KEY;

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let stored: string | null = null;
    try {
      stored = window.localStorage.getItem(STORAGE_KEY);
    } catch {
      stored = null;
    }
    if (!stored) {
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    if (!visible) {
      document.body.classList.remove("has-cookie-bar");
      return undefined;
    }
    document.body.classList.add("has-cookie-bar");
    return () => {
      document.body.classList.remove("has-cookie-bar");
    };
  }, [visible]);

  const handleAccept = () => {
    applyConsent("granted");
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[95] border-t border-background-200 bg-background-50 animate-fade-up"
      role="region"
      aria-labelledby="cookie-title"
      aria-describedby="cookie-description"
    >
      <div className="mx-auto w-full max-w-[1240px] px-4 py-3 md:px-6 md:py-8">
        <div className="flex flex-col gap-2 md:flex-row md:items-center md:gap-10">
          <div className="flex min-w-0 items-start gap-3 md:items-center md:gap-4">
            <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-secondary-100 md:h-14 md:w-14 md:rounded-xl">
              <i className="ri-shield-check-line text-lg text-primary-700 md:text-2xl" />
            </span>
            <div className="min-w-0 md:max-w-[620px]">
              <h2
                id="cookie-title"
                className="font-heading text-[15px] font-bold leading-tight text-foreground-950 md:text-xl"
              >
                Sua privacidade importa
              </h2>
              <p
                id="cookie-description"
                className="mt-0.5 text-xs leading-snug text-foreground-700 md:mt-1.5 md:text-[15px] md:leading-relaxed"
              >
                <span className="md:hidden">
                  Usamos cookies.{" "}
                  <Link
                    to="/politica-de-privacidade"
                    className="font-semibold text-primary-700 underline underline-offset-2 transition-colors duration-200 hover:text-primary-800 cursor-pointer"
                  >
                    Política de Privacidade
                  </Link>
                </span>
                <span className="hidden md:inline">
                  Usamos cookies para melhorar sua experiência, analisar o tráfego e personalizar
                  anúncios. Ao continuar navegando, você concorda com nossa{" "}
                  <Link
                    to="/politica-de-privacidade"
                    className="font-semibold text-primary-700 underline underline-offset-2 transition-colors duration-200 hover:text-primary-800 cursor-pointer"
                  >
                    Política de Privacidade
                  </Link>
                  .
                </span>
              </p>
            </div>
          </div>

          <div className="flex w-full items-center gap-2.5 md:ml-auto md:w-auto md:flex-shrink-0 md:gap-4">
            <Link
              to="/politica-de-privacidade"
              className="inline-flex flex-1 items-center justify-center whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-xs font-semibold text-foreground-800 transition-colors duration-200 hover:bg-background-100 md:flex-none md:px-6 md:py-3.5 md:text-[15px] cursor-pointer"
            >
              Saiba mais
            </Link>
            <button
              type="button"
              onClick={handleAccept}
              className="inline-flex flex-1 items-center justify-center whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-xs font-bold text-background-50 transition-colors duration-200 hover:bg-primary-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:ring-offset-2 md:flex-none md:px-6 md:py-3.5 md:text-[15px] cursor-pointer"
            >
              Aceitar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}